import { render, staticRenderFns } from "./GeneralDetailsForm.vue?vue&type=template&id=75ed8d58"
import script from "./GeneralDetailsForm.vue?vue&type=script&lang=js"
export * from "./GeneralDetailsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports